import { Icon, Stack } from "@fluentui/react";
import { ChoiceGroup, IChoiceGroupOption } from "@fluentui/react/lib/ChoiceGroup";
import { TooltipHost } from "@fluentui/react/lib/Tooltip";
import { wizardStyles } from "cayo.ui.wizards";
import { Dispatch, FC } from "react";
import { useIntl } from "react-intl";
import styled from "styled-components";
import { messages } from "../../messages";
import { IUpdateWizardAction } from "../../reducer";

interface ISelectMethod {
  dispatchWizardState: Dispatch<IUpdateWizardAction>;
}

const SelectMethod: FC<ISelectMethod> = ({ dispatchWizardState }) => {
  const intl = useIntl();

  const handleChangeConfig = (key: string) => {
    let connectionType = true;
    if (key === "legacy") {
      connectionType = false;
    }

    dispatchWizardState({
      action: "setConnectionType",
      newState: { connectionIsRecommended: connectionType },
    });
  };

  const options: IChoiceGroupOption[] = [
    {
      key: "recommended",
      text: intl.formatMessage(messages.selectMethodPrincipal),
      ariaLabel: intl.formatMessage(messages.selectMethodPrincipal),
      onRenderField: (props, render) => {
        return (
          <OptionWrap>
            {render!(props)}
            <TooltipHost
              content={`${intl.formatMessage(messages.tooltipMethodPrincipal)}`}
              id={intl.formatMessage(messages.tooltipMethodPrincipal)}
            >
              <Icon
                iconName={"Info"}
                aria-describedby={intl.formatMessage(messages.tooltipMethodPrincipal)}
              />
            </TooltipHost>
          </OptionWrap>
        );
      },
    },
    {
      key: "legacy",
      text: intl.formatMessage(messages.selectMethodConnectOld),
      ariaLabel: intl.formatMessage(messages.selectMethodConnectOld),
      onRenderField: (props, render) => {
        return (
          <OptionWrap>
            {render!(props)}
            <TooltipHost
              content={`${intl.formatMessage(messages.tooltipMethodConnectOld)}`}
              id={intl.formatMessage(messages.tooltipMethodConnectOld)}
            >
              <Icon
                iconName={"Info"}
                aria-describedby={intl.formatMessage(messages.tooltipMethodConnectOld)}
              />
            </TooltipHost>
          </OptionWrap>
        );
      },
    },
  ];
  return (
    <Stack
      horizontal={false}
      tokens={wizardStyles.stackTokens}
      styles={{ root: { maxWidth: wizardStyles.maxPageWidth } }}
    >
      <Label>
        {intl.formatMessage(messages.selectMethodConnect)} <Asterisk className="label">*</Asterisk>
      </Label>
      <ChoiceGroup
        defaultSelectedKey="recommended"
        options={options}
        onChange={(_, option) => handleChangeConfig(option?.key || "recommended")}
      />

      <Link href="https://support.cayosoft.com/hc/en-us/articles/37330345941901" target="_blank">
        {intl.formatMessage(messages.selectMethodConnectReadMore)}
      </Link>
    </Stack>
  );
};

const Label = styled.p`
  position: relative;
  margin-bottom: 0px;
  font-size: 14px;
  font-weight: 600 !important;

  .label: {
    color: red;
  }
`;

const Link = styled.a`
  padding-top: 20px;
`;

const Asterisk = styled.span`
  color: red;
`;

const OptionWrap = styled.div`
  position: relative;
  display: flex;
  gap: 5px;
`;

export default SelectMethod;
